import React, { useState } from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
import logo from "../assets/line.png";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";
import { CgGitFork } from "react-icons/cg";
import { ImBlog } from "react-icons/im";
import {
  AiFillStar,
  AiOutlineHome,
  AiOutlineFundProjectionScreen,
  AiOutlineUser,
} from "react-icons/ai";

import { CgFileDocument } from "react-icons/cg";

function NavBar() {
  const [expand, updateExpanded] = useState(false);
  const [navColour, updateNavbar] = useState(false);

  // compact nav item styles: single-line line-height and reduced padding
  const navLinkStyle = { lineHeight: 0, padding: "0px" };
  const navHeaderStyle = { fontSize: "1.1rem", lineHeight: 1, padding: "2px 8px 10px 2px" };

  function scrollHandler() {
    if (window.scrollY >= 20) {
      updateNavbar(true);
    } else {
      updateNavbar(false);
    }
  }

  function handleEmailClick() {
    window.location.href = "mailto:skyjungofficial@gmail.com";
  }

  window.addEventListener("scroll", scrollHandler);

  return (
    
    <Navbar
      expanded={expand}
      fixed="top"
      expand="md"
      className={`navbar ${expand ? "expanded" : ""}`}
    >
      <Container style={{'minWidth': '100%'}}>
       <Navbar.Toggle
          aria-controls="responsive-navbar-nav"
          onClick={() => updateExpanded(!expand)}
          className="sticky"
        >
          <span></span>
          <span></span>
          <span></span>
        </Navbar.Toggle>
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav
            className="ms-auto flex-column"
            defaultActiveKey="#home"
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              height: "100vh",
              paddingBottom: "5rem",
            }}
          >
            <div style={{display: "flex", flexDirection: "column"}}>
              <Nav.Item className="nav-header" style={navHeaderStyle}>
              <div className="nav-title">Sky Jung</div>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link as={Link} to="/" onClick={() => updateExpanded(false)} style={navLinkStyle}>
                home
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link as={Link} to="/paintings" onClick={() => updateExpanded(false)} style={navLinkStyle}>
                paintings
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link as={Link} to="/exhibits" onClick={() => updateExpanded(false)} style={navLinkStyle}>
                exhibits
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link as={Link} to="/films" onClick={() => updateExpanded(false)} style={navLinkStyle}>
                film
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link href="https://docentofficial.com" target="_blank" onClick={() => updateExpanded(false)} style={navLinkStyle}>
                docent
              </Nav.Link>
            </Nav.Item>

            </div>
            
            <div id="contact" style={{display: "flex", flexDirection: "column"}}>
              <Nav.Item>
                <Nav.Link as={Link} to="/contact" onClick={() => updateExpanded(false)} style={navLinkStyle}>
                  contact
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link href="https://www.instagram.com/skydjung" target="_blank" onClick={() => updateExpanded(false)} style={navLinkStyle}>
                  instagram
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link href="https://skyjung.substack.com/" target="_blank" onClick={() => updateExpanded(false)} style={navLinkStyle}>
                  substack
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link  onClick={() =>handleEmailClick()} style={navLinkStyle}>
                  email
                </Nav.Link>
              </Nav.Item>
            </div>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavBar;
